export const DEPARTMENT_TYPES = {
  PRODUCTION: 'Производственное',
  SERVICE: 'Обслуживание',
}

export const DEPARTMENT_TYPE_OPTIONS = [
  { value: DEPARTMENT_TYPES.PRODUCTION, label: 'Производственное' },
  { value: DEPARTMENT_TYPES.SERVICE, label: 'Обслуживание' },
]
